import dayjs from 'dayjs';

export function getFullDate() {
  return dayjs().format('dddd, D MMMM YYYY');
}

export function getNextYear() {
  return dayjs().add(1, 'year').format('YY');
}

export function getTodaysDate() {
  return dayjs().format('D-MMM-YYYY');
}

export function formatDateFilter(dateObj: Date) {
  return dayjs(dateObj).format('D-M-YYYY');
}
